// @flow

import * as React from 'react';
import styled from '@emotion/styled';
import cx from 'classnames';

type Props = {
  children?: React.ReactNode,
  className?: string
};

const defaultProps = {
  children: null,
  className: undefined
};

const Wrapper = styled.div({});

const Column: React.FC<Props> = ({ children, className, ...rest }: Props) => (
  <Wrapper className={cx('column', className)} {...rest}>
    {children}
  </Wrapper>
);

Column.defaultProps = defaultProps;

export default Column;
